import { render, staticRenderFns } from "./orgchartOfCompany.vue?vue&type=template&id=142e3bc5"
import script from "./orgchartOfCompany.vue?vue&type=script&lang=js"
export * from "./orgchartOfCompany.vue?vue&type=script&lang=js"
import style0 from "./orgchartOfCompany.vue?vue&type=style&index=0&id=142e3bc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports